import React from 'react';
import { Link as MuiLink } from '@mui/material';
import { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { routerService } from '../../services';

export const Link = (props: MuiLinkProps) => {
    const onClick = () => {
        if (props.href && (props.target === undefined || props.target === '_self')) {
            routerService.navigateByUrl(props.href);
        }
    };

    const sx = {
        ...props.sx,
        width: '100%',
        height: '100%',
    };

    return <MuiLink {...props} sx={sx} onClick={onClick} />;
};
